export const SCREEN_BREAKPOINTS = {
  DEFAULT: 0,
  XS: 450,
  SM: 720,
  MD: 900,
  LG: 1076,
  XL: 1300,
  "2XL": 1614,
  "3XL": 1920,
  "4XL": 2300,
};
